import {
  ADD_DRAFT,
  REMOVE_DRAFT,
  UPDATE_DRAFT,
  SET_DRAFTS_FOR_BLOG
} from '../actions/draftsActions';

const initialState = {
  data: [],
  metadata: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_DRAFT: return onAddDraft(state, action);
    case REMOVE_DRAFT: return onRemoveDraft(state, action);
    case UPDATE_DRAFT: return onUpdateDraft(state, action);
    case SET_DRAFTS_FOR_BLOG: return onSetDraftsForBlog(state, action);
    default:
      return state;
  }
}

const onSetDraftsForBlog = (state, action) => {
  console.log(action);
  return { 
    data: [...action.drafts],
    metadata: action.metadata
  }
}

const onRemoveDraft = (state, action) => {
  return {
    metadata: state.metadata,
    data: state.data.filter(draft => draft._id !== action.id)
  }
}

const onAddDraft = (state, action) => {
  let newDrafts = state.data.filter(() => true);

  newDrafts.push(action.draft);

  return {
    metadata: state.metadata,
    data: newDrafts
  };
}

const onUpdateDraft = (state, action) => {
  
  let newDrafts = state.data.filter(() => true);

  for(let i in newDrafts) {
    if(newDrafts[i]._id === action.draft._id) {
      Object.assign(newDrafts[i], action.draft);
      break;
    }
  }

  return {
    metadata: state.metadata,
    data: newDrafts
  };
}